import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const H3 = styled('h3')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17.5px;
  color: ${theme.palette.text.dark};
  margin: 0;
`;
